import type { AvailableLocales } from "@onclicks/sharedmobilei18n/routing";
import fr from "@onclicks/sharedmobilei18n/translates/fr.json";
import en from "@onclicks/sharedmobilei18n/translates/en.json";
import nl from "@onclicks/sharedmobilei18n/translates/nl.json";
import { ApiError } from "../types/errors/api-error";

type ErrorMessages = Record<string, string> & { default: string };

const ERROR_MESSAGES: Record<AvailableLocales, ErrorMessages> = {
  fr: fr.errors,
  en: en.errors,
  nl: nl.errors,
};

// Code d'erreur métier -> code impératif (toasts, catch()) hors du rendu
// React : impossible d'y appeler useTranslations(). On garde donc la locale
// courante en variable de module, synchronisée par <ApiErrorLocaleSync />.
let currentLocale: AvailableLocales = "fr";

export function setApiErrorLocale(locale: AvailableLocales) {
  currentLocale = locale;
}

export function translateApiError(error: unknown): string {
  const messages = ERROR_MESSAGES[currentLocale];

  if (error instanceof ApiError) {
    const message = messages[String(error.code)];
    if (!message) {
      console.warn(
        `Code d'erreur non traduit: ${error.code} (${error.type})`,
      );
      return messages.default;
    }
    return message;
  }

  return messages.default;
}

// Message traduit suivi du code d'erreur backend entre parenthèses, pour que
// le support puisse identifier l'erreur à partir d'une capture du toast. Pas de
// code pour les erreurs hors ApiError ni pour le code 0 (réponse non-JSON).
export function translateApiErrorWithCode(error: unknown): string {
  const message = translateApiError(error);
  if (error instanceof ApiError && error.code > 0) {
    return `${message} (${error.code})`;
  }
  return message;
}
